import { render, staticRenderFns } from "./ProjectActivitySmallCard.vue?vue&type=template&id=735d73f7"
import script from "./ProjectActivitySmallCard.vue?vue&type=script&lang=ts"
export * from "./ProjectActivitySmallCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735d73f7')) {
      api.createRecord('735d73f7', component.options)
    } else {
      api.reload('735d73f7', component.options)
    }
    module.hot.accept("./ProjectActivitySmallCard.vue?vue&type=template&id=735d73f7", function () {
      api.rerender('735d73f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ProjectActivitySmallCard.vue"
export default component.exports